import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import {hasError} from '../utils.js';

const NAMESPACE = '[store]';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {

    },
    session: {
      valid: true,
      winner: null,
      confettiPlaying: false,
      prizeID: null,
      legal: false,
      legalHeader: 'legal',
      error: null,
      userData: {
        name: null,
        email: null,
        phone: null,
        address: null,
        city: null,
        province: null,
        postalCode: null,
      },
      egg: {
        idle: true,
      }
    },
  },

  getters: {
    isWinner: state => {
      return state.session.winner;
    },

    prizeID: state => {
      return state.session.prizeID;
    },

    isValidSession: state => {
      return state.session.valid;
    },

    isShowingLegal: state => {
      return state.session.legal;
    },

    legalState: state => {
      return state.session.legalHeader;
    },

    hasFailure: state => {
      return state.session.error;
    },

    eggIsIdle: state => {
      return state.session.egg.idle;
    },

    userSubmitData: state => {
      let userFormData = {};

      userFormData = Object.assign(state.session.userData);
      userFormData['prizeID'] = state.session.prizeID;

      return userFormData;
    },

    isConfettiPlaying: state => {
      return state.session.confettiPlaying;
    },

  },

  mutations: {
    activateEgg(state){
      state.session.egg.idle = false;
    },

    storeUserData(state, payload){
      state.session.userData.name = payload.name;
      state.session.userData.email = payload.email;
      state.session.userData.phone = payload.phone;
      state.session.userData.address = payload.address;
      state.session.userData.city = payload.city;
      state.session.userData.province = payload.province;
      state.session.userData.postalCode = payload.postalCode;
    },

    deactivateEgg(state){
      state.session.egg.idle = true;
    },

    assignWinResults(state, payload){
      state.session.winner = payload.won;
      state.session.prizeID = payload.prizeID;
    },

    assignUser(state, payload){
      state.user = payload.user;
    },

    invalidSession(state){
      state.session.valid = false;
    },

    validSession(state){
      state.session.valid = true;
    },

    showLegal(state, payload){
      state.session.legal = payload.visibilityFlag
      state.session.legalHeader = payload.legalHeader
    },

    callFailure(state, payload){
      state.session.error = payload.error
    },

    showConfetti(state) {
      console.log(NAMESPACE, 'showConfetti')
      state.session.confettiPlaying = true;
    },

    hideConfetti(state) {
      state.session.confettiPlaying = false;
    },



  },

  actions: {

    getResults ({ commit }) {
      return new Promise((resolve, reject) => {

        axios({
          method: 'POST',
          url: process.env.VUE_APP_API_DIRECTORY,
          data: {
            action: 'won',
          },
        }).then((response) => {
              commit('assignWinResults', response.data);
              console.log('player results: ', response)

              if(!hasError(response.data)){
                console.log('hasError resolve');
                resolve(response.data.won);

              } else {
                console.log('hasError reject');
                reject(response.data.won);
              }

          })
          .catch((error) => {
            let payload = {
              error: 'Fail: getResults()'
            };

            commit('callFailure', payload);
            console.log('error: ', error);
            reject(error);

          });


      })
    },

    createUser({commit}, userData ){

      return new Promise((resolve, reject) => {

        axios({
          method: 'POST',
          url: process.env.VUE_APP_API_DIRECTORY,
          data: {
            'action': 'claim',
            'name': userData.name,
            'email': userData.email,
            'phone': userData.phone,
            'address': userData.address,
            'city': userData.city,
            'province': userData.province,
            'postalCode': userData.postalCode,
            'prizeID': userData.prizeID
          },
        }).then((response) => {
              commit('assignUser', response.data);

              if(hasError(response.data)){
                resolve(response.data, true);
              } else {
                resolve(response.data);
              }

          })
          .catch((error) => {

            let payload = {
              error: 'Fail: createUser()'
            };

            commit('callFailure', payload);
            // $cookies.remove('hershey');
            reject(error);

          });

      })


    },

  },

  modules: {
  }

})
